export default __webpack_public_path__ + "static/media/4.aa0cd1a1.jpg";